module.exports = __webpack_public_path__ + "static/media/FDLogobook.d04ade60.png";